import $ from 'jquery';
import { defaults, find } from 'lodash';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import LucidJS from 'lucidjs';
import videojs from 'video.js';

import supportsNativeTextTracks from 'pages/open-course/video/util/supportsNativeTextTracks';

import 'bundles/videojs/plugins/circlePlayButton';
import 'bundles/videojs/plugins/fullScreenButton';
import 'bundles/videojs/plugins/heartbeat';
import 'bundles/videojs/plugins/muteToggle';
import 'bundles/videojs/plugins/playToggle';
import 'bundles/videojs/plugins/settingsMenuButton';
import 'bundles/videojs/plugins/subtitlesMenuButton';
import 'bundles/videojs/plugins/volumeMenuButton';

export type videojsCourseraOptions = {
  width?: number;
  height?: number;
  videoSubtitlesDisabled?: boolean;
  defaultSubtitleLanguage?: string;
  playerOptions?: videojs.PlayerOptions;
};

export const getFlexDefaults = function (
  videojsCourseraOptions: Pick<videojsCourseraOptions, 'videoSubtitlesDisabled' | 'defaultSubtitleLanguage'> = {}
): videojs.PlayerOptions {
  // We're going to go ahead and replace the elements of any buttons with
  // icons so that we can use font-awesome class-based icons instead.
  // These elements are too small to put in their own files, so we use one
  // file to house them all.

  return {
    fluid: true,
    controls: true,
    html5: {
      nativeTextTracks: supportsNativeTextTracks(),
    },
    children: {
      // @ts-expect-error TSMIGRATION
      mediaLoader: {},
      posterImage: {},
      textTrackDisplay: {},
      loadingSpinner: {},
      circlePlayButton: {},
      controlBar: {
        children: [
          'progressControl',
          'cPlayToggle',
          'currentTimeDisplay',
          'timeDivider',
          'durationDisplay',
          ...(!videojsCourseraOptions.videoSubtitlesDisabled
            ? [
                {
                  name: 'subtitlesMenuButton',
                  ...(videojsCourseraOptions.defaultSubtitleLanguage
                    ? { defaultSubtitleLanguage: videojsCourseraOptions.defaultSubtitleLanguage }
                    : {}),
                },
              ]
            : []),
          {
            name: 'cVolumeMenuButton',
            children: ['cMuteToggle'],
            inline: false,
            vertical: true,
          },
          'settingsMenuButton',
          'cFullscreenToggle',
        ],
      },
      errorDisplay: {},
      textTrackSettings: {},
    },
  };
};

const attachListeners = function (player: videojs.Player) {
  player.one('play', function () {
    if (player.autoplay()) {
      // @ts-expect-error TSMIGRATION
      $(player.el_).focus();
    }
  });
};

const VideoPlayer = function (
  id: any,
  videojsPlayerOptions: videojs.PlayerOptions & { defaultSubtitleLanguage?: string } = {}
): videojs.Player {
  const options: videojs.PlayerOptions = defaults(
    videojsPlayerOptions,
    getFlexDefaults({ defaultSubtitleLanguage: videojsPlayerOptions.defaultSubtitleLanguage })
  );

  const player = videojs(id, options);
  attachListeners(player);

  // @ts-expect-error TSMIGRATION
  if (!player.emitter) {
    // All custom events should be sent on the Lucid emitter
    // @ts-expect-error TSMIGRATION
    player.emitter = LucidJS.emitter();
  }

  // @ts-expect-error TSMIGRATION
  player.setupHeartbeatListener();

  // @ts-expect-error TSMIGRATION
  player.currentTrack = function () {
    return find(
      player
        // @ts-expect-error TSMIGRATION
        .textTracks(),
      (track) => track.mode === 'showing'
    );
  };

  return player;
};

export default VideoPlayer;
